import PropertyInstruction from "./PropertyInstruction";
import {useHome} from "./HomeContext";


const HomePropertyInstruction = () => {
    const {propertyInstructions, updateHome} = useHome();

    return <PropertyInstruction propertyInstructions={propertyInstructions}
                                onSave={updateHome} />
}


export default HomePropertyInstruction;